import appConfig from '../config'

export const getStateCodeFromPostalcode = async (
  postalCode: string
): Promise<{ valid: boolean; state: string }> => {
  const { GATEKEEPER_BASE_URL } = appConfig

  const response = await fetch(
    `${GATEKEEPER_BASE_URL}/v1/zipCodes/zipcodes/${postalCode}/state`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }
  )
  const data = await response.json()

  return data
}

export default getStateCodeFromPostalcode
